import { create } from 'zustand';

import type { PageCabinetBlockItem } from '@/components/common/Providers/GraphqlProvider/generated';

type Store = {
  currentCabinet: PageCabinetBlockItem;
  addCurrentCabinet: (data: PageCabinetBlockItem) => void;
};

export const useCabinet = create<Store>()((set) => ({
  currentCabinet: {} as PageCabinetBlockItem,

  addCurrentCabinet: (data) => set({ currentCabinet: data }),
}));
